import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GallerySectionSchema } from '../types/GallerySectionSchema';

const initialState: GallerySectionSchema = {
    
};

export const GallerySectionSlice = createSlice({
    name: 'GallerySection',
    initialState,
    reducers: {
        template: (state, action: PayloadAction<string>) => {
           
        },
    },
    // extraReducers: (builder) => {
    //     builder
    //         .addCase(, (state) => {
    //             state.error = undefined;
    //             state.isLoading = true;
    //         })
    //         .addCase(, (state) => {
    //             state.isLoading = false;
    //         })
    //         .addCase(, (state, action) => {
    //             state.isLoading = false;
    //             state.error = action.payload;
    //         });
    // },
});

export const { actions: GallerySectionActions } = GallerySectionSlice;
export const { reducer: GallerySectionReducer } = GallerySectionSlice;